
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as pool_S_hgOwVHSi0Hoa7vPl22zC2vXylyezGSNCfM5Ts_qQMeta } from "/opt/build/repo/app/pages/pool.vue?macro=true";
export default [
  {
    name: "vendors-claims-id",
    path: "/vendors/claims/:id()",
    meta: {"middleware":"require-vendor"},
    component: () => import("/opt/build/repo/app/pages/vendors/claims/[id].vue")
  },
  {
    name: "claims-id",
    path: "/claims/:id()",
    component: () => import("/opt/build/repo/app/pages/claims/[id].vue")
  },
  {
    name: "apply",
    path: "/apply",
    component: () => import("/opt/build/repo/app/pages/apply.vue")
  },
  {
    name: "balances",
    path: "/balances",
    component: () => import("/opt/build/repo/app/pages/balances.vue")
  },
  {
    name: "claims",
    path: "/claims",
    component: () => import("/opt/build/repo/app/pages/claims/index.vue")
  },
  {
    name: "membership",
    path: "/membership",
    component: () => import("/opt/build/repo/app/pages/membership.vue")
  },
  {
    name: pool_S_hgOwVHSi0Hoa7vPl22zC2vXylyezGSNCfM5Ts_qQMeta?.name,
    path: "/pool",
    meta: {"middleware":"require-distribution"},
    component: () => import("/opt/build/repo/app/pages/pool.vue"),
    children: [
  {
    name: "pool-distribution",
    path: "distribution",
    component: () => import("/opt/build/repo/app/pages/pool/distribution.vue")
  },
  {
    name: "pool-members",
    path: "members",
    component: () => import("/opt/build/repo/app/pages/pool/members.vue")
  },
  {
    name: "pool-policies",
    path: "policies",
    component: () => import("/opt/build/repo/app/pages/pool/policies.vue")
  },
  {
    name: "pool-prompts",
    path: "prompts",
    component: () => import("/opt/build/repo/app/pages/pool/prompts.vue")
  },
  {
    name: "pool-vendors",
    path: "vendors",
    component: () => import("/opt/build/repo/app/pages/pool/vendors.vue")
  },
  {
    name: "pool",
    path: "",
    component: () => import("/opt/build/repo/app/pages/pool/index.vue")
  }
]
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/opt/build/repo/app/pages/privacy.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/opt/build/repo/app/pages/terms.vue")
  },
  {
    name: "vendors",
    path: "/vendors",
    meta: {"middleware":"require-vendor"},
    component: () => import("/opt/build/repo/app/pages/vendors/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/app/pages/index.vue")
  }
]